import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mParticleSelectPlacements, canUseMParticle } from './RoktMParticle';
import { RoktPlaceholder } from './Rokt';
import { getOrderTotal } from '../../selectors/cart';
import { toDecimals } from '../../helpers/currency';

class RoktPayment extends Component {
  initialized = false; // run only once when everything is loaded we don't care about next changes to store
  placementSelection = null;

  componentDidUpdate() {
    this.run();
  }

  componentDidMount() {
    this.run();
  }

  componentWillUnmount() {
    this.placementSelection?.close();
  }

  run = async () => {
    const canRun = canUseMParticle();
    if (this.props.data?.attributes && canRun) {
      if (this.initialized) {
        return;
      } else {
        this.initialized = true;
      }
      if (canRun) {
        try {
          const { identifier }     = this.props.data;
          const orderTotalDecimals = toDecimals(this.props.orderTotal);
          const payload = {
            ...this.props.data.attributes,
            amount: orderTotalDecimals,
          };
          this.placementSelection = await mParticleSelectPlacements(identifier, payload);
        } catch(err) {
          console.error('Error displaying Rokt payment selection: ' + err);
        }
      }
    }
  }

  render() {
    return <RoktPlaceholder />;
  }
}

const mapStateToProps = (state) => {
  return {
    data: state?.reservation?.roktPayload,
    orderTotal: getOrderTotal(state),
  };
};

export default connect(mapStateToProps)(RoktPayment);
